<template>
<div class="chapter">
<div class="inner_page">
<p class="chapter-h1"><span>Also by Michael Z. Lewin</span></p>
<p class="center3" style="margin-top:40px;"><b>The Albert Samson Mysteries</b></p>
<p class="center3">Ask the Right Question</p>
<p class="center3">The Way We Die Now</p>
<p class="center3">The Enemies Within</p>
<p class="center3">The Silent Salesman</p>
<p class="center3">Missing Woman</p>
<p class="center3">Out of Season</p>
<p class="center3">Called By a Panther</p>
<p class="center3">Eye Opener</p>
<p class="center3" style="margin-top:20px;"><b>The Lt. Leroy Powder Mysteries</b></p>
<p class="center3">Night Cover</p>
<p class="center3">Hard Line</p>
<p class="center3">Late Payments</p>
<p class="center3" style="margin-top:20px;"><b>Indianapolis Novels</b></p>
<p class="center3">Outside In</p>
<p class="center3">And Baby Will Fall</p>
<p class="center3">Underdog</p>
<p class="center3">Oh Joe</p>
<p class="center3" style="margin-top:20px;"><b>The Lunghi Family Mysteries</b></p>
<p class="center3">Family Business</p>
<p class="center3">Family Planning</p>
<p class="center3">Family Way</p>
<p class="center3" style="margin-top:20px;"><b>Other Novels</b></p>
<p class="center3">Cutting Loose</p>
<p class="center3">Confessions of a Discontented Deity</p>
<p class="center3" style="margin-top:20px;"><b>Story Collections</b></p>
<p class="center3">Telling Tails</p>
<p class="center3">Rover’s Tales</p>
<p class="center3">The Reluctant Detective and other stories</p>
<p class="center3">Family Trio</p>
<p class="center3" style="margin-top:20px;"><b>Nonfiction</b></p>
<p class="center3">How to Beat College Tests: A Guide to Ease the Burden of Useless Courses</p>
<p class="center3" style="margin-top:20px;"><b>Novelization</b></p>
<p class="center3">The Next Man</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titles.vue?7b643984